
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9917"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9917"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("18sGY", function(module, exports) {

$parcel$export(module.exports, "StorageReadySignal", () => $0d3ccb766a58e4d7$export$cb17db694ed87275);
$parcel$export(module.exports, "WorkerErrorSignal", () => $0d3ccb766a58e4d7$export$472a8b902c3377c2);
$parcel$export(module.exports, "StorageResultSignal", () => $0d3ccb766a58e4d7$export$a5e4b727846d6d00);
$parcel$export(module.exports, "ScopeSwitched", () => $0d3ccb766a58e4d7$export$c0a1ccfe080ee02f);
$parcel$export(module.exports, "TaskAdded", () => $0d3ccb766a58e4d7$export$a3f0e342be5a9897);
$parcel$export(module.exports, "TaskStatusUpdated", () => $0d3ccb766a58e4d7$export$82df4004064f122);
$parcel$export(module.exports, "TaskUpdated", () => $0d3ccb766a58e4d7$export$bd8d3d267ae5edc7);
$parcel$export(module.exports, "ExportDataFromDB", () => $0d3ccb766a58e4d7$export$bd13ff936ce5a136);
$parcel$export(module.exports, "ImportDataToDB", () => $0d3ccb766a58e4d7$export$f1aebeccda93d9cf);
$parcel$export(module.exports, "DataExported", () => $0d3ccb766a58e4d7$export$b936f6ff7b9f79cf);
$parcel$export(module.exports, "default", () => $0d3ccb766a58e4d7$export$2e2bcd8739ae039);
class $0d3ccb766a58e4d7$var$Signal {
    constructor(payload = null){
        this.signal = this.constructor.name;
        this.payload = payload;
    }
}
class $0d3ccb766a58e4d7$export$54197de32491308c extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$cb17db694ed87275 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$472a8b902c3377c2 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$f6a63b7e7169a01a extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$6f9dffe06ecd604d extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$a5e4b727846d6d00 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$c0a1ccfe080ee02f extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$a3f0e342be5a9897 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$82df4004064f122 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$bd8d3d267ae5edc7 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$a13999b94a9b1af1 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$d7c0687fb3960ed6 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$bd13ff936ce5a136 extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$f1aebeccda93d9cf extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$b936f6ff7b9f79cf extends $0d3ccb766a58e4d7$var$Signal {
}
class $0d3ccb766a58e4d7$export$8a484ec46ab5cbea extends $0d3ccb766a58e4d7$var$Signal {
}
const $0d3ccb766a58e4d7$var$mapOptimised = (signal)=>{
    const signalMap = {
        [$0d3ccb766a58e4d7$export$54197de32491308c.name]: 'InitStorageSignal',
        [$0d3ccb766a58e4d7$export$cb17db694ed87275.name]: 'StorageReadySignal',
        [$0d3ccb766a58e4d7$export$472a8b902c3377c2.name]: 'WorkerErrorSignal',
        [$0d3ccb766a58e4d7$export$f6a63b7e7169a01a.name]: 'StorageQuerySignal',
        [$0d3ccb766a58e4d7$export$6f9dffe06ecd604d.name]: 'StorageCommandSignal',
        [$0d3ccb766a58e4d7$export$a5e4b727846d6d00.name]: 'StorageResultSignal',
        [$0d3ccb766a58e4d7$export$c0a1ccfe080ee02f.name]: 'ScopeSwitched',
        [$0d3ccb766a58e4d7$export$a3f0e342be5a9897.name]: 'TaskAdded',
        [$0d3ccb766a58e4d7$export$82df4004064f122.name]: 'TaskStatusUpdated',
        [$0d3ccb766a58e4d7$export$bd8d3d267ae5edc7.name]: 'TaskUpdated',
        [$0d3ccb766a58e4d7$export$a13999b94a9b1af1.name]: 'TaskCancelled',
        [$0d3ccb766a58e4d7$export$d7c0687fb3960ed6.name]: 'TaskCompleted',
        [$0d3ccb766a58e4d7$export$bd13ff936ce5a136.name]: 'ExportDataFromDB',
        [$0d3ccb766a58e4d7$export$f1aebeccda93d9cf.name]: 'ImportDataToDB',
        [$0d3ccb766a58e4d7$export$b936f6ff7b9f79cf.name]: 'DataExported'
    };
    return signalMap[signal] || signal;
};
var $0d3ccb766a58e4d7$export$2e2bcd8739ae039 = $0d3ccb766a58e4d7$var$mapOptimised;

});

var $24f6cd628db71622$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    function t(n, r) {
        for(var t, u = [], a = e(n, r, 0, u); a && (t = u.pop()); a = e(t.a, t.b, 0, u));
        return a;
    }
    function e(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && p(5), !1;
        if (t > 100) return u.push(i(n, r)), !0;
        for(var a in 0 > n.$ && (n = wr(n), r = wr(r)), n)if (!e(n[a], r[a], t + 1, u)) return !1;
        return !0;
    }
    function u(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = u(n.a, r.a)) || (t = u(n.b, r.b)) ? t : u(n.c, r.c);
        for(; n.b && r.b && !(t = u(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var a = F2(function(n, r) {
        var t = u(n, r);
        return 0 > t ? pr : t ? hr : gr;
    });
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function o(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function c(n) {
        return n;
    }
    function f(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function s(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = l(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = l(n.a, r);
        return t;
    }
    var v = {
        $: 0
    };
    function l(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var b = F2(l);
    function d(n) {
        for(var r = v, t = n.length; t--;)r = l(n[t], r);
        return r;
    }
    var g = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), h = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, i(t, r);
    });
    function p(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var $ = Math.ceil, m = Math.floor, w = Math.log, y = F2(function(n, r) {
        return n + r;
    }), x = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], i = t.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += t[u], u++), r = A2(n, c(a), r);
        }
        return r;
    }), k = F2(function(n, r) {
        return r.join(n);
    }), j = F3(function(n, r, t) {
        return t.slice(n, r);
    }), A = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    });
    function z(n) {
        return {
            $: 2,
            b: n
        };
    }
    var E = z(function(n) {
        return "number" != typeof n ? M("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Ar(n) : !isFinite(n) || n % 1 ? M("an INT", n) : Ar(n);
    }), _ = (z(function(n) {
        return "boolean" == typeof n ? Ar(n) : M("a BOOL", n);
    }), z(function(n) {
        return "number" == typeof n ? Ar(n) : M("a FLOAT", n);
    }), z(function(n) {
        return Ar(n);
    })), N = z(function(n) {
        return "string" == typeof n ? Ar(n) : n instanceof String ? Ar(n + "") : M("a STRING", n);
    }), L = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), T = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function C(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var O = F2(function(n, r) {
        return C(n, [
            r
        ]);
    }), U = F3(function(n, r, t) {
        return C(n, [
            r,
            t
        ]);
    }), R = F5(function(n, r, t, e, u) {
        return C(n, [
            r,
            t,
            e,
            u
        ]);
    }), D = F7(function(n, r, t, e, u, a, i) {
        return C(n, [
            r,
            t,
            e,
            u,
            a,
            i
        ]);
    }), F = F2(function(n, r) {
        return S(n, r);
    });
    function S(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Ar(n.c) : M("null", r);
            case 3:
                return B(r) ? I(n.b, r, d) : M("a LIST", r);
            case 4:
                return B(r) ? I(n.b, r, q) : M("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return M("an OBJECT with a field named `" + t + "`", r);
                var e = S(n.b, r[t]);
                return Qr(e) ? e : yr(A2(kr, t, e.a));
            case 7:
                var u = n.e;
                return B(r) ? r.length > u ? (e = S(n.b, r[u]), Qr(e) ? e : yr(A2(jr, u, e.a))) : M("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : M("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || B(r)) return M("an OBJECT", r);
                var a = v;
                for(var o in r)if (r.hasOwnProperty(o)) {
                    if (e = S(n.b, r[o]), !Qr(e)) return yr(A2(kr, o, e.a));
                    a = l(i(o, e.a), a);
                }
                return Ar(Tr(a));
            case 9:
                for(var c = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = S(f[s], r), !Qr(e)) return e;
                    c = c(e.a);
                }
                return Ar(c);
            case 10:
                return e = S(n.b, r), Qr(e) ? S(n.h(e.a), r) : e;
            case 11:
                for(var b = v, g = n.g; g.b; g = g.b){
                    if (e = S(g.a, r), Qr(e)) return e;
                    b = l(e.a, b);
                }
                return yr(zr(Tr(b)));
            case 1:
                return yr(A2(xr, n.a, r));
            case 0:
                return Ar(n.a);
        }
    }
    function I(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = S(n, r[a]);
            if (!Qr(i)) return yr(A2(jr, a, i.a));
            u[a] = i.a;
        }
        return Ar(t(u));
    }
    function B(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function q(n) {
        return A2(Kr, n.length, function(r) {
            return n[r];
        });
    }
    function M(n, r) {
        return yr(A2(xr, "Expecting " + n, r));
    }
    function P(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return P(n.b, r.b);
            case 6:
                return n.d === r.d && P(n.b, r.b);
            case 7:
                return n.e === r.e && P(n.b, r.b);
            case 9:
                return n.f === r.f && H(n.g, r.g);
            case 10:
                return n.h === r.h && P(n.b, r.b);
            case 11:
                return H(n.g, r.g);
        }
    }
    function H(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!P(n[e], r[e])) return !1;
        return !0;
    }
    function Y(n) {
        return n;
    }
    function G(n) {
        return n;
    }
    var W = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function Z(n) {
        return {
            $: 0,
            a: n
        };
    }
    function J(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var V = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), K = 0;
    function Q(n) {
        var r = {
            $: 0,
            e: K++,
            f: n,
            g: null,
            h: []
        };
        return tn(r), r;
    }
    function X(n, r) {
        n.h.push(r), tn(n);
    }
    var nn = !1, rn = [];
    function tn(n) {
        if (rn.push(n), !nn) {
            for(nn = !0; n = rn.shift();)en(n);
            nn = !1;
        }
    }
    function en(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, tn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var un = {};
    function an(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(V, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = Q(A2(V, o, n.b));
    }
    var on = F2(function(n, r) {
        return J(function(t) {
            n.g(r), t(Z(0));
        });
    });
    function cn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    var fn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), sn = [], vn = !1;
    function ln(n, r, t) {
        if (sn.push({
            p: n,
            q: r,
            r: t
        }), !vn) {
            vn = !0;
            for(var e; e = sn.shift();)bn(e.p, e.q, e.r);
            vn = !1;
        }
    }
    function bn(n, r, t) {
        var e = {};
        for(var u in dn(!0, r, e, null), dn(!1, t, e, null), n)X(n[u], {
            $: "fx",
            a: e[u] || {
                i: v,
                j: v
            }
        });
    }
    function dn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? un[r].e : un[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: v,
                        j: v
                    }, n ? t.i = l(r, t.i) : t.j = l(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)dn(n, i.a, t, e);
                return;
            case 3:
                return void dn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function gn(n) {
        un[n] && p(3);
    }
    var hn = F2(function(n, r) {
        return r;
    });
    function pn(n) {
        var r = [], t = un[n].u, e = J(function(n) {
            var r = setTimeout(function() {
                n(Z(0));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return un[n].b = e, un[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = G(t(u.a)), o = 0; a.length > o; o++)a[o](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    var $n = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    var mn = "undefined" != typeof document ? document : {};
    function wn(n, r) {
        n.appendChild(r);
    }
    function yn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var xn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: En(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: En(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var kn, jn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), An = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), zn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function En(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? _n(i, u, a) : i[u] = a;
            } else "className" === u ? _n(r, u, G(a)) : r[u] = G(a);
        }
        return r;
    }
    function _n(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Nn(n, r) {
        var t = n.$;
        if (5 === t) return Nn(n.k || (n.k = n.m()), r);
        if (0 === t) return mn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Nn(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Ln(i = n.h(n.g), r, n.d), i;
        var i = n.f ? mn.createElementNS(n.f, n.c) : mn.createElement(n.c);
        Ln(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)wn(i, Nn(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function Ln(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Tn(n, u) : "a0" === e ? Un(n, r, u) : "a3" === e ? Cn(n, u) : "a4" === e ? On(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Tn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Cn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function On(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Un(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Rn(r, a), n.addEventListener(u, i, kn && {
                    passive: 2 > tt(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                kn = !0;
            }
        }));
    } catch (n) {}
    function Rn(n, r) {
        function t(r) {
            var e = t.q, u = S(e.a, r);
            if (Qr(u)) {
                for(var a, i = tt(e), o = u.a, c = i ? 3 > i ? o.a : o.aN : o, f = 1 == i ? o.b : 3 == i && o.V, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.S) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var v = a.length; v--;)c = a[v](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function Dn(n, r) {
        return n.$ == r.$ && P(n.a, r.a);
    }
    function Fn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Sn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Fn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Sn(n.k, r.k, s, 0), void (s.length > 0 && Fn(t, 1, e, s));
                case 4:
                    for(var v = n.j, l = r.j, b = !1, d = n.k; 4 === d.$;)b = !0, "object" != typeof v ? v = [
                        v,
                        d.j
                    ] : v.push(d.j), d = d.k;
                    for(var g = r.k; 4 === g.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        g.j
                    ] : l.push(g.j), g = g.k;
                    return b && v.length !== l.length ? void Fn(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(v, l) : v === l) || Fn(t, 2, e, l), void Sn(d, g, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Fn(t, 3, e, r.a));
                case 1:
                    return void In(n, r, t, e, qn);
                case 2:
                    return void In(n, r, t, e, Mn);
                case 3:
                    if (n.h !== r.h) return void Fn(t, 0, e, r);
                    var h = Bn(n.d, r.d);
                    h && Fn(t, 4, e, h);
                    var p = r.i(n.g, r.g);
                    return void (p && Fn(t, 5, e, p));
            }
        }
    }
    function In(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Bn(n.d, r.d);
            a && Fn(t, 4, e, a), u(n, r, t, e);
        } else Fn(t, 0, e, r);
    }
    function Bn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Dn(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Bn(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function qn(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Fn(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Fn(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            Sn(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Mn(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, v = 0, l = 0, b = e; f > v && s > l;){
            var d = (z = o[v]).a, g = (E = c[l]).a, h = z.b, p = E.b, $ = void 0, m = void 0;
            if (d !== g) {
                var w = o[v + 1], y = c[l + 1];
                if (w) {
                    var x = w.a, k = w.b;
                    m = g === x;
                }
                if (y) {
                    var j = y.a, A = y.b;
                    $ = d === j;
                }
                if ($ && m) Sn(h, A, u, ++b), Hn(a, u, d, p, l, i), b += h.b || 0, Yn(a, u, d, k, ++b), b += k.b || 0, v += 2, l += 2;
                else if ($) b++, Hn(a, u, g, p, l, i), Sn(h, A, u, b), b += h.b || 0, v += 1, l += 2;
                else if (m) Yn(a, u, d, h, ++b), b += h.b || 0, Sn(k, p, u, ++b), b += k.b || 0, v += 2, l += 1;
                else {
                    if (!w || x !== j) break;
                    Yn(a, u, d, h, ++b), Hn(a, u, g, p, l, i), b += h.b || 0, Sn(k, A, u, ++b), b += k.b || 0, v += 2, l += 2;
                }
            } else Sn(h, p, u, ++b), b += h.b || 0, v++, l++;
        }
        for(; f > v;){
            var z;
            b++, Yn(a, u, (z = o[v]).a, h = z.b, b), b += h.b || 0, v++;
        }
        for(; s > l;){
            var E, _ = _ || [];
            Hn(a, u, (E = c[l]).a, E.b, void 0, _), l++;
        }
        (u.length > 0 || i.length > 0 || _) && Fn(t, 8, e, {
            w: u,
            x: i,
            y: _
        });
    }
    var Pn = "_elmW6BL";
    function Hn(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Sn(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Hn(n, r, t + Pn, e, u, a);
    }
    function Yn(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Sn(e, a.z, i, u), void Fn(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Yn(n, r, t + Pn, e, u);
        } else {
            var o = Fn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function Gn(n, r, t, e) {
        Wn(n, r, t, 0, 0, r.b, e);
    }
    function Wn(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) Gn(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && Wn(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, v = o.s;
                v && (v.A.s = n, (s = v.w).length > 0 && Wn(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var l = r.$;
        if (4 === l) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return Wn(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var d = r.e, g = n.childNodes, h = 0; d.length > h; h++){
            u++;
            var p = 1 === l ? d[h] : d[h].b, $ = u + (p.b || 0);
            if (!(u > c || c > $ || (o = t[e = Wn(g[h], p, t, e, u, $, i)]) && (c = o.r) <= a)) return e;
            u = $;
        }
        return e;
    }
    function Zn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Jn(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Jn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Nn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Ln(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Zn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Nn(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Zn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = mn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                wn(t, 2 === u.c ? u.s : Nn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Zn(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : Nn(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && wn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                p(10);
        }
    }
    function Vn(n) {
        if (3 === n.nodeType) return yn(n.textContent);
        if (1 !== n.nodeType) return yn("");
        for(var r = v, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = l(A2(zn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = v, o = n.childNodes;
        for(e = o.length; e--;)i = l(Vn(o[e]), i);
        return A3(xn, a, r, i);
    }
    var Kn = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var i = A2(F, n, r ? r.flags : void 0);
            Qr(i) || p(2);
            var o = {}, c = t(i.a), f = c.a, s = a(l, f), v = function(n, r) {
                var t;
                for(var e in un){
                    var u = un[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = an(u, r);
                }
                return t;
            }(o, l);
            function l(n, r) {
                var t = A2(e, n, f);
                s(f = t.a, r), ln(o, t.b, u(f));
            }
            return ln(o, c.b, u(f)), v ? {
                ports: v
            } : {};
        }(r, e, n.aL, n.aY, n.aW, function(r, t) {
            var u = n.aZ, a = e.node, i = Vn(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Qn(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Qn(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Sn(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Gn(n, r, t, e), Zn(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), Qn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Xn, nr = F3(function(n, r, t) {
        return n.setInt8(r, t), r + 1;
    }), rr = F4(function(n, r, t, e) {
        return n.setInt16(r, t, e), r + 2;
    }), tr = F4(function(n, r, t, e) {
        return n.setInt32(r, t, e), r + 4;
    }), er = F3(function(n, r, t) {
        return n.setUint8(r, t), r + 1;
    }), ur = F4(function(n, r, t, e) {
        return n.setUint16(r, t, e), r + 2;
    }), ar = F4(function(n, r, t, e) {
        return n.setUint32(r, t, e), r + 4;
    }), ir = F4(function(n, r, t, e) {
        return n.setFloat32(r, t, e), r + 4;
    }), or = F4(function(n, r, t, e) {
        return n.setFloat64(r, t, e), r + 8;
    }), cr = F3(function(n, r, t) {
        for(var e = 0, u = t.byteLength, a = u - 4; a >= e; e += 4)n.setUint32(r + e, t.getUint32(e));
        for(; u > e; e++)n.setUint8(r + e, t.getUint8(e));
        return r + u;
    }), fr = F3(function(n, r, t) {
        for(var e = 0; t.length > e; e++){
            var u = t.charCodeAt(e);
            r += 128 > u ? (n.setUint8(r, u), 1) : 2048 > u ? (n.setUint16(r, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(r, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(r + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + t.charCodeAt(++e) - 56320 + 65536, n.setUint32(r, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return r;
    }), sr = F2(function(n, r) {
        var t = "g";
        n.aO && (t += "m"), n.aD && (t += "i");
        try {
            return Er(RegExp(r, t));
        } catch (n) {
            return _r;
        }
    }), vr = F2(function(n, r) {
        return null !== r.match(n);
    });
    z(function(n) {
        return "undefined" != typeof File && n instanceof File ? Ar(n) : M("a FILE", n);
    });
    var lr, br = F3(function(n, r, t) {
        return J(function() {
            var e = new Blob([
                t
            ], {
                type: r
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(e, n);
            else {
                var u = Xn || (Xn = document.createElement("a")), a = URL.createObjectURL(e);
                u.href = a, u.download = n, dr(u), URL.revokeObjectURL(a);
            }
        });
    });
    function dr(n) {
        if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
        else {
            var r = document.createEvent("MouseEvents");
            r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(r), document.body.removeChild(n);
        }
    }
    var gr = 1, hr = 2, pr = 0, $r = b, mr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(mr, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), wr = function(n) {
        return A3(mr, F3(function(n, r, t) {
            return A2($r, i(n, r), t);
        }), v, n);
    }, yr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), kr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ar = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Er = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _r = {
        $: 1
    }, Nr = F2(function(n, r) {
        return A2(k, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), Lr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Tr = function(n) {
        return A3(Lr, $r, v, n);
    }, Cr = 32, Or = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ur = [], Rr = $, Dr = F2(function(n, r) {
        return w(r) / w(n);
    }), Fr = Rr(A2(Dr, 2, Cr)), Sr = A4(Or, 0, Fr, Ur, Ur), Ir = g, Br = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qr = m, Mr = function(n) {
        return n.length;
    }, Pr = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), Hr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yr = h, Gr = F2(function(n, r) {
        for(;;){
            var t = A2(Yr, Cr, n), e = t.b, u = A2($r, Hr(t.a), r);
            if (!e.b) return Tr(u);
            n = e, r = u;
        }
    }), Wr = function(n) {
        return n.a;
    }, Zr = F2(function(n, r) {
        for(;;){
            var t = Rr(r / Cr);
            if (1 === t) return A2(Yr, Cr, n).a;
            n = A2(Gr, n, v), r = t;
        }
    }), Jr = F2(function(n, r) {
        if (r.a) {
            var t = r.a * Cr, e = qr(A2(Dr, Cr, t - 1)), u = n ? Tr(r.d) : r.d, a = A2(Zr, u, r.a);
            return A4(Or, Mr(r.c) + t, A2(Pr, 5, e * Fr), a, r.c);
        }
        return A4(Or, Mr(r.c), Fr, Ur, r.c);
    }), Vr = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(Jr, !1, {
                d: e,
                a: t / Cr | 0,
                c: u
            });
            var a = Br(A3(Ir, Cr, r, n));
            r -= Cr, e = A2($r, a, e);
        }
    }), Kr = F2(function(n, r) {
        if (n > 0) {
            var t = n % Cr;
            return A5(Vr, r, n - t - Cr, n, v, A3(Ir, t, n - t, r));
        }
        return Sr;
    }), Qr = function(n) {
        return !n.$;
    }, Xr = O, nt = U, rt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, et = j, ut = function() {
        for(;;);
    }, at = Z, it = at(0), ot = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, t > 500 ? A3(Lr, n, r, Tr(s)) : A4(ot, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), ct = F3(function(n, r, t) {
        return A4(ot, n, r, 0, t);
    }), ft = F2(function(n, r) {
        return A3(ct, F2(function(r, t) {
            return A2($r, n(r), t);
        }), v, r);
    }), st = V, vt = F2(function(n, r) {
        return A2(st, function(r) {
            return at(n(r));
        }, r);
    }), lt = F3(function(n, r, t) {
        return A2(st, function(r) {
            return A2(st, function(t) {
                return at(A2(n, r, t));
            }, t);
        }, r);
    }), bt = on, dt = F2(function(n, r) {
        var t = r;
        return function(n) {
            return J(function(r) {
                r(Z(Q(n)));
            });
        }(A2(st, bt(n), t));
    });
    un.Task = {
        b: it,
        c: F3(function(n, r) {
            var t;
            return A2(vt, function() {
                return 0;
            }, (t = A2(ft, dt(n), r), A3(ct, lt($r), at(v), t)));
        }),
        d: F3(function() {
            return at(0);
        }),
        e: F2(function(n, r) {
            return A2(vt, n, r);
        }),
        f: undefined
    };
    var gt, ht, pt, $t, mt = cn("Task"), wt = F2(function(n, r) {
        return mt(A2(vt, n, r));
    }), yt = Kn, xt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kt = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, At = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zt = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return n.a.byteLength;
        }
    }, Et = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return A3(nr, r, t, n.a);
            case 1:
                return A4(rr, r, t, n.b, !n.a);
            case 2:
                return A4(tr, r, t, n.b, !n.a);
            case 3:
                return A3(er, r, t, n.a);
            case 4:
                return A4(ur, r, t, n.b, !n.a);
            case 5:
                return A4(ar, r, t, n.b, !n.a);
            case 6:
                return A4(ir, r, t, n.b, !n.a);
            case 7:
                return A4(or, r, t, n.b, !n.a);
            case 8:
                return A3(_t, n.b, r, t);
            case 9:
                return A3(fr, r, t, n.b);
            default:
                return A3(cr, r, t, n.a);
        }
    }), _t = F3(function(n, r, t) {
        for(;;){
            if (!n.b) return t;
            var e = n.b, u = r, a = A3(Et, n.a, r, t);
            n = e, r = u, t = a;
        }
    }), Nt = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Lt = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.b;
            n += zt(r.a), r = t;
        }
    }), Tt = function(n) {
        var r, t, e;
        return e = Tr(n), r = A2(Nt, A2(Lt, 0, e), e), t = new DataView(new ArrayBuffer(zt(r))), Et(r)(t)(0), t;
    }, Ct = F2(function(n, r) {
        return r.$ ? yr(r.a) : n(r.a);
    }), Ot = {
        $: -2
    }, Ut = Ot, Rt = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Dt = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Rt, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(Rt, 0, e.b, e.c, A5(Rt, 1, a.b, a.c, a.d, a.e), A5(Rt, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Rt, n, o, c, A5(Rt, 0, r, t, e, f), s) : A5(Rt, 0, r, t, A5(Rt, 1, e.b, e.c, e.d, i = e.e), A5(Rt, 1, o, c, f, s));
    }), Ft = a, St = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Rt, 0, n, r, Ot, Ot);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(Ft, n, u)){
            case 0:
                return A5(Dt, e, u, a, A3(St, n, r, i), o);
            case 1:
                return A5(Rt, e, u, r, i, o);
            default:
                return A5(Dt, e, u, a, i, A3(St, n, r, o));
        }
    }), It = F3(function(n, r, t) {
        var e = A3(St, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Rt, 1, e.b, e.c, e.d, e.e);
    }), Bt = (gt = d([
        i("A", 0),
        i("B", 1),
        i("C", 2),
        i("D", 3),
        i("E", 4),
        i("F", 5),
        i("G", 6),
        i("H", 7),
        i("I", 8),
        i("J", 9),
        i("K", 10),
        i("L", 11),
        i("M", 12),
        i("N", 13),
        i("O", 14),
        i("P", 15),
        i("Q", 16),
        i("R", 17),
        i("S", 18),
        i("T", 19),
        i("U", 20),
        i("V", 21),
        i("W", 22),
        i("X", 23),
        i("Y", 24),
        i("Z", 25),
        i("a", 26),
        i("b", 27),
        i("c", 28),
        i("d", 29),
        i("e", 30),
        i("f", 31),
        i("g", 32),
        i("h", 33),
        i("i", 34),
        i("j", 35),
        i("k", 36),
        i("l", 37),
        i("m", 38),
        i("n", 39),
        i("o", 40),
        i("p", 41),
        i("q", 42),
        i("r", 43),
        i("s", 44),
        i("t", 45),
        i("u", 46),
        i("v", 47),
        i("w", 48),
        i("x", 49),
        i("y", 50),
        i("z", 51),
        i("0", 52),
        i("1", 53),
        i("2", 54),
        i("3", 55),
        i("4", 56),
        i("5", 57),
        i("6", 58),
        i("7", 59),
        i("8", 60),
        i("9", 61),
        i("+", 62),
        i("/", 63)
    ]), A3(Lr, F2(function(n, r) {
        return A3(It, n.a, n.b, r);
    }), Ut, gt)), qt = y, Mt = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return _r;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(Ft, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Er(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Pt = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 2;
            case 2:
                return 4;
            default:
                return 6;
        }
    }, Ht = F2(function(n, r) {
        return r >>> Pt(n);
    }), Yt = F3(function(n, r, t) {
        return t | A2(Ht, n, r);
    }), Gt = F2(function(n, r) {
        return r << Pt(n);
    }), Wt = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = function() {
            switch(t){
                case 0:
                    return A2(Gt, 1, n);
                case 1:
                    return A2(Gt, 2, n);
                case 2:
                    return A2(Gt, 3, n);
                default:
                    return 0;
            }
        }(), i = function() {
            switch(t){
                case 0:
                    return _r;
                case 1:
                    return Er(A3(Yt, 2, n, e));
                case 2:
                    return Er(A3(Yt, 1, n, e));
                default:
                    return Er(e | n);
            }
        }(), c = i.$ ? u : A2($r, {
            $: 3,
            a: i.a
        }, u);
        return o(function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                default:
                    return 0;
            }
        }(t), a, c);
    }), Zt = x, Jt = o(0, 0, v), Vt = F2(function(n, r) {
        return r.$ ? _r : Er(n(r.a));
    }), Kt = F2(function(n, r) {
        return r.$ ? yr(r.a) : Ar(n(r.a));
    }), Qt = F2(function(n, r) {
        return 1 > n ? r : A3(et, 0, -n, r);
    }), Xt = A, ne = vr, re = sr, te = /.^/, ee = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), ue = function(n) {
        return A2(ne, A2(ee, te, A2(re, {
            aD: !1,
            aO: !1
        }, "^[A-Za-z0-9\\/+]*$")), n) ? Ar(n) : yr(0);
    }, ae = function(n) {
        return A2(Kt, A2(Zt, F2(function(n, r) {
            return A2(ee, r, A2(Vt, function(n) {
                return A2(Wt, n, r);
            }, function(n) {
                return A2(Mt, function(n) {
                    return A2(qt, n, "");
                }(n), Bt);
            }(n)));
        }), Jt), A2(Ct, ue, function(n) {
            return Ar(A2(Xt, "==", n) ? A2(Qt, 2, n) : A2(Xt, "=", n) ? A2(Qt, 1, n) : n);
        }(n)));
    }, ie = function(n) {
        var r = ae(n);
        return r.$ ? yr(r.a) : Ar(Tt(r.a.c));
    }, oe = F2(function(n, r) {
        return n(r);
    }), ce = F, fe = L, se = N, ve = _, le = A3(nt, F2(function(n, r) {
        return {
            x: r,
            as: n
        };
    }), A2(fe, "signal", se), A2(fe, "payload", ve)), be = F6(function(n, r, t, e, u, a) {
        return {
            f: n,
            C: e,
            D: u,
            an: t,
            at: r,
            e: a
        };
    }), de = D, ge = function(n) {
        return {
            $: 11,
            g: d([
                A2(Xr, Er, n),
                rt(_r)
            ])
        };
    }, he = F4(function(n, r, t, e) {
        return {
            f: n,
            P: r,
            ar: e,
            l: t
        };
    }), pe = E, $e = function(n) {
        switch(n){
            case 0:
            default:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
        }
    }, me = A5(R, he, A2(fe, "id", se), A2(fe, "note", se), A2(Xr, $e, A2(fe, "status", pe)), A2(fe, "scopeId", se)), we = {
        $: 3,
        b: me
    }, ye = A7(de, be, A2(fe, "id", se), A2(fe, "stamp", se), A2(fe, "recapitulatedAt", ge(se)), A2(fe, "nextScopeId", ge(se)), A2(fe, "previousScopeId", ge(se)), A2(fe, "tasks", we)), xe = T, ke = A3(nt, F2(function(n, r) {
        return i(n, r);
    }), A2(xe, 0, se), A2(Xr, $e, A2(xe, 1, pe))), je = function(n) {
        var r = A2(ce, le, n);
        if (r.$) return jt(At(yr(r.a)));
        var t = r.a;
        switch(t.as){
            case "tasks":
                var e = A2(ce, we, t.x);
                return jt({
                    $: 0,
                    a: e.$ ? yr(e.a) : Ar(e.a)
                });
            case "TaskAdded":
                var u = A2(ce, me, t.x);
                return jt(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u.$ ? yr(u.a) : Ar(u.a)));
            case "TaskUpdated":
                var a = A2(ce, me, t.x);
                return jt(function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(a.$ ? yr(a.a) : Ar(a.a)));
            case "TaskStatusUpdated":
                var i = A2(ce, ke, t.x);
                return jt(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(i.$ ? yr(i.a) : Ar(i.a)));
            case "ScopeSwitched":
                var o = A2(ce, ye, t.x);
                return jt(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(o.$ ? yr(o.a) : Ar(o.a)));
            case "DataExported":
                var c = A2(ce, se, t.x);
                if (c.$) return jt(kt(yr(c.a)));
                var f = A2(oe, ie, c.a);
                return jt(f.$ ? {
                    $: 8,
                    a: yr(f.a)
                } : kt(Ar(f.a)));
            default:
                return jt(At(yr(A2(xr, "Message signal uknowwn", n))));
        }
    }, Ae = (pt = ve, gn(ht = "results"), un[ht] = {
        f: $n,
        u: pt,
        a: function(n, r) {
            var t = v, e = un[n].u, u = Z(null);
            return un[n].b = u, un[n].c = F3(function(n, r) {
                return t = r, u;
            }), {
                send: function(n) {
                    var u = A2(F, e, n);
                    Qr(u) || p(4);
                    for(var a = u.a, i = t; i.b; i = i.b)r(i.a(a));
                }
            };
        }
    }, cn(ht)), ze = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Ee = function(n) {
        return {
            $: 11,
            a: n
        };
    }, _e = F3(function(n, r, t) {
        var e;
        return A2(wt, ut, A3(br, n, r, (e = t, new Uint8Array(e.buffer, e.byteOffset, e.byteLength))));
    }), Ne = function(n) {
        return A3(Lr, F2(function(n, r) {
            return A3(W, n.a, n.b, r);
        }), {}, n);
    }, Le = function(n) {
        switch(n){
            case 0:
                return "GetScope";
            case 1:
                return "CreateTask";
            case 2:
                return "CancelTask";
            case 3:
                return "CompleteTask";
            case 4:
                return "RestoreTask";
            case 5:
                return "UpdateTask";
            case 6:
                return "RecapitulateScope";
            case 7:
                return "ExportDataFromDB";
            default:
                return "ImportDataToDB";
        }
    }, Te = Y, Ce = F2(function(n, r) {
        return Ne(d([
            i("op", Te(Le(n))),
            i("payload", r)
        ]));
    }), Oe = F2(function(n, r) {
        return Ne(d([
            i("id", Te(n)),
            i("note", Te(r))
        ]));
    }), Ue = Y, Re = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, De = F2(function(n, r) {
        return A2(wt, r, function(n) {
            return J(function(r) {
                (lr = document.createElement("input")).type = "file", lr.accept = A2(Nr, ",", n), lr.addEventListener("change", function(n) {
                    r(Z(n.target.files[0]));
                }), dr(lr);
            });
        }(n));
    }), Fe = F2(function(n, r) {
        return A3(ct, F2(function(r, t) {
            return n(r) ? A2($r, r, t) : t;
        }), v, r);
    }), Se = fn, Ie = {
        $: 2,
        m: v
    }, Be = function(n, r) {
        return gn(n), un[n] = {
            e: hn,
            u: r,
            a: pn
        }, cn(n);
    }("queries", function(n) {
        return n;
    }), qe = function(n) {
        return n.$ ? "" : n.a;
    }, Me = F3(function(n, r, e) {
        return A2(ft, function(e) {
            return t(e.f, n) ? f(e, {
                l: r
            }) : e;
        }, e);
    }), Pe = F2(function(n, r) {
        if (1 === n.$) {
            var e = n.a;
            switch(e.$){
                case 0:
                    return y = Be(A2(Ce, 0, Te(qe(e.a)))), i(r, y);
                case 2:
                    return "" === r.v.trim() ? i(r, Ie) : function(n) {
                        return i(f(r, {
                            v: ""
                        }), n);
                    }(Be((w = A4(he, "new-id", r.v, 0, qe(r.H)), A2(Ce, 1, Ne(d([
                        i("id", Te((p = w).f)),
                        i("note", Te(p.P)),
                        i("status", Ue(Re(p.l))),
                        i("scopeId", Te(p.ar))
                    ]))))));
                case 1:
                    return i(f(r, {
                        v: e.a
                    }), Ie);
                case 3:
                    return i(r, Be(A2(Ce, e.b, Te(u = e.a))));
                case 4:
                    var u = e.a, a = function(n) {
                        return n.b ? Er(n.a) : _r;
                    }(A2(Fe, function(n) {
                        return t(n.f, u);
                    }, r.e));
                    return i(f(r, a.$ ? {
                        r: "",
                        z: _r
                    } : {
                        r: a.a.P,
                        z: Er(u)
                    }), Ie);
                case 5:
                    return i(f(r, {
                        r: e.a
                    }), Ie);
                case 6:
                    return u = (m = r.z).$ ? "" : m.a, i(r, Be(A2(Ce, 5, A2(Oe, u, r.r))));
                case 7:
                    return i(r, Be(A2(Ce, 0, Te(e.a))));
                case 8:
                    return i(r, Be(A2(Ce, 6, Te(e.a))));
                case 9:
                    return i(r, Be(A2(Ce, 7, null)));
                case 10:
                    return i(r, A2(Se, xt, A2(De, v, Ee)));
                case 11:
                    return i(r, A2(Se, xt, A2(wt, ze, (h = e.a, J(function(n) {
                        var r = new FileReader;
                        return r.addEventListener("loadend", function() {
                            n(Z(r.result));
                        }), r.readAsDataURL(h), function() {
                            r.abort();
                        };
                    })))));
                default:
                    return i(r, Be(A2(Ce, 8, Te(e.a))));
            }
        } else {
            var o = n.a;
            switch(o.$){
                case 0:
                    return i(o.a.$ ? r : f(r, {
                        e: o.a.a
                    }), Ie);
                case 1:
                    return i(o.a.$ ? r : f(r, {
                        e: s(r.e, d([
                            o.a.a
                        ]))
                    }), Ie);
                case 2:
                    if (o.a.$) return i(r, Ie);
                    var c = o.a.a;
                    return i(f(r, {
                        e: A3(Me, u = c.a, c.b, r.e)
                    }), Ie);
                case 3:
                    return i(o.a.$ ? r : f(r, {
                        e: A3(Me, u = o.a.a, 2, r.e)
                    }), Ie);
                case 4:
                    if (o.a.$) return i(r, Ie);
                    var l = o.a.a, b = A2(ft, function(n) {
                        return t(n.f, l.f) ? l : n;
                    }, r.e);
                    return i(f(r, {
                        r: "",
                        z: _r,
                        e: b
                    }), Ie);
                case 5:
                    if (o.a.$) return i(r, Ie);
                    var g = o.a.a;
                    return i(f(r, {
                        H: Er(g.f),
                        N: ($ = g.an, !$.$),
                        O: Er(g.at),
                        C: g.C,
                        D: g.D,
                        e: g.e
                    }), Ie);
                case 7:
                    return i(r, o.a.$ ? Ie : A3(_e, "recapi_export.sqlite3", "application/octet-stream", o.a.a));
                default:
                    return i(r, Ie);
            }
        }
        var h, p, $, m, w, y;
    }), He = {
        $: 2
    }, Ye = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ge = xn("button"), We = F2(function(n, r) {
        return A2(An, n, Te(r));
    }), Ze = We("className"), Je = F3(function(n, r, t) {
        return r(n(t));
    }), Ve = xn("div"), Ke = xn("form"), Qe = function(n) {
        return n.b;
    }, Xe = function(n) {
        return Ze(A2(Nr, " ", A2(ft, Wr, A2(Fe, Qe, n))));
    }, nu = xn("span"), ru = yn, tu = F2(function(n, r) {
        return A2(nu, d([
            Xe(d([
                i("icon", !0),
                i(n, !0),
                i(r, !0)
            ]))
        ]), d([
            ru("")
        ]));
    }), eu = A2(tu, "icon-plus", "size-lg"), uu = xn("input"), au = function(n) {
        return i(n, !0);
    }, iu = jn, ou = F2(function(n, r) {
        return A2(iu, n, {
            $: 1,
            a: r
        });
    }), cu = A2(F2(function(n, r) {
        return A3(ct, fe, r, n);
    }), d([
        "target",
        "value"
    ]), se), fu = function(n) {
        return A2(ou, "input", A2(Xr, au, A2(Xr, n, cu)));
    }, su = function(n) {
        return i(n, !0);
    }, vu = F2(function(n, r) {
        return A2(iu, n, {
            $: 2,
            a: r
        });
    }), lu = function(n) {
        return A2(vu, "submit", A2(Xr, su, rt(n)));
    }, bu = We("placeholder"), du = xn("section"), gu = We("type"), hu = We("value"), pu = xn("main"), $u = xn("header"), mu = xn("br"), wu = A2(du, d([
        Ze("text-lg")
    ]), d([
        ru("Recapitulation is a simple task management application designed to help you keep track of your tasks efficiently."),
        A2(mu, v, v),
        ru("Features include adding, editing, completing, and cancelling tasks, as well as navigating between different scopes of tasks.")
    ])), yu = xn("details"), xu = A2(tu, "icon-info", "size-lg"), ku = xn("summary"), ju = We("title"), Au = A2(yu, d([
        Ze("dropdown"),
        ju("About Recapitulation")
    ]), d([
        A2(ku, d([
            Ze("btn btn-ghost btn-circle btn-lg")
        ]), d([
            xu
        ])),
        A2(Ve, d([
            Ze("dropdown-content card w-96 p-4 bg-base-100 shadow-lg mt-2")
        ]), d([
            A2(Ve, d([
                Ze("card-body")
            ]), d([
                A2($u, d([
                    Ze("card-title")
                ]), d([
                    ru("Recapitulation")
                ])),
                wu
            ]))
        ]))
    ])), zu = xn("nav"), Eu = function(n) {
        return {
            $: 8,
            a: n
        };
    }, _u = A2(tu, "icon-backward", "size-lg"), Nu = A2(tu, "icon-recap", "size-lg"), Lu = A2(tu, "icon-forward", "size-lg"), Tu = F2(function(n, r) {
        return A2(iu, n, {
            $: 0,
            a: r
        });
    }), Cu = function(n) {
        return A2(Tu, "click", rt(n));
    }, Ou = F4(function(n, r, t, e) {
        if (r.$) return t ? A2(Ge, d([
            Cu(xt(Eu(e))),
            Ze("join-item btn btn-secondary btn-lg"),
            ju("Recapitulate")
        ]), d([
            Nu
        ])) : A2(Ge, d([
            Ze("join-item btn btn-primary btn-lg w-16")
        ]), d([
            ru("")
        ]));
        var u, a = t ? "Next" : "Previous", i = t ? Lu : _u;
        return A2(Ge, d([
            Cu(xt((u = r.a, {
                $: 7,
                a: u
            }))),
            Ze("join-item btn btn-primary btn-lg"),
            ju(a)
        ]), d([
            i
        ]));
    }), Uu = A2(tu, "icon-export", "size-sm"), Ru = A2(tu, "icon-import", "size-sm"), Du = A2(tu, "icon-settings", "size-lg"), Fu = xn("li"), Su = xn("ul"), Iu = A2(yu, d([
        Ze("dropdown dropdown-end"),
        ju("Settings")
    ]), d([
        A2(ku, d([
            Ze("btn btn-ghost btn-circle btn-lg")
        ]), d([
            Du
        ])),
        A2(Su, d([
            Ze("dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 mt-2")
        ]), d([
            A2(Fu, v, d([
                A2(Ge, d([
                    Cu(xt({
                        $: 9
                    })),
                    Ze("btn btn-ghost w-full justify-start")
                ]), d([
                    Uu,
                    ru(" Export Data")
                ]))
            ])),
            A2(Fu, v, d([
                A2(Ge, d([
                    Cu(xt({
                        $: 10
                    })),
                    Ze("btn btn-ghost w-full justify-start")
                ]), d([
                    Ru,
                    ru(" Import Data")
                ]))
            ]))
        ]))
    ])), Bu = function(n) {
        var r, t, e = (r = n.O).$ ? "No Scope" : r.a, u = n.D, a = n.C, i = (t = n.H).$ ? "" : t.a;
        return A2($u, d([
            Ze("flex justify-between items-center navbar p-0")
        ]), d([
            Au,
            A2(zu, d([
                Ze("join")
            ]), d([
                A4(Ou, "<<", u, !1, i),
                A2(Ge, d([
                    Ze("join-item btn btn-primary btn-lg")
                ]), d([
                    ru(e)
                ])),
                A4(Ou, ">>", a, !0, i)
            ])),
            Iu
        ]));
    }, qu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Mu = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Pu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Hu = {
        $: 6
    }, Yu = A2(tu, "icon-discard", "size-lg"), Gu = A2(tu, "icon-save", "size-lg"), Wu = F3(function(n, r, e) {
        return !n.l && t(Er(n.f), r) ? A2(Ke, d([
            lu(xt(Hu)),
            Ze("flex flex-row align-center")
        ]), d([
            A2(Ge, d([
                gu("button"),
                Cu(xt(qu(""))),
                Ze("btn btn-secondary btn-sm mr-2 outline-none")
            ]), d([
                Yu
            ])),
            A2(uu, d([
                gu("text"),
                hu(e),
                fu(A2(Je, Pu, xt)),
                Ze("w-full input flex-1 outline-none text-lg h-auto")
            ]), v),
            A2(Ge, d([
                gu("submit"),
                Ze("btn btn-secondary btn-sm ml-2 outline-none")
            ]), d([
                Gu
            ]))
        ])) : A2(nu, d([
            Ze("text-lg")
        ]), d([
            ru(n.P)
        ]));
    }), Zu = A2(tu, "icon-cancel", "size-lg"), Ju = A2(tu, "icon-edit", "size-lg"), Vu = F3(function(n, r, t) {
        return A2(Ge, d([
            Cu(xt(n)),
            Xe(d([
                i("btn btn-primary btn-sm btn-ghost btn-circle invisible group-hover:visible", !0),
                i(t, !0)
            ]))
        ]), d([
            r
        ]));
    }), Ku = A2(tu, "icon-check", "size-lg"), Qu = A2(tu, "icon-restore", "size-lg"), Xu = F4(function(n, r, e, u) {
        var a = t(Er(u.f), n) ? A2(Ve, d([
            Ze("size-lg")
        ]), d([
            ru("")
        ])) : function(n) {
            var r = n.l ? 4 : 3, t = function() {
                switch(n.l){
                    case 3:
                        return ru("");
                    case 0:
                        return Ku;
                    default:
                        return Qu;
                }
            }(), e = n.l;
            return A2(Ve, d([
                Ze("size-lg")
            ]), d(3 === e ? [
                ru("")
            ] : [
                A3(Vu, A2(Mu, n.f, r), t, "")
            ]));
        }(u), o = !u.l && !t(Er(u.f), n), c = o ? A3(Vu, qu(u.f), Ju, "mr-1") : ru(""), f = o ? A3(Vu, A2(Mu, u.f, 2), Zu, "") : ru("");
        return A2(Ve, d([
            Xe(d([
                i("grid grid-cols-[32px_1fr_32px_32px]", !0),
                i("group bg-size-[5px] bg-bottom bg-repeat-x hover:bg-(image:--bg-dots)", !e)
            ]))
        ]), d([
            a,
            A2(Ve, d([
                Xe(d([
                    i("px-1 pt-[0.15rem] flex-1", !0),
                    i("text-primary", 1 === u.l),
                    i("text-primary line-through", 2 === u.l),
                    i("line-through", 3 === u.l)
                ]))
            ]), d([
                A3(Wu, u, n, r)
            ])),
            A2(Ve, d([
                Ze("size-lg")
            ]), d([
                c
            ])),
            A2(Ve, d([
                Ze("size-lg")
            ]), d([
                f
            ]))
        ]));
    }), na = F4(function(n, r, t, e) {
        return A2(du, v, A2(ft, A3(Xu, r, t, e), n));
    });
    $t = {
        Recapi: {
            init: yt({
                aL: function() {
                    return i({
                        H: _r,
                        N: !1,
                        O: _r,
                        r: "",
                        v: "",
                        C: _r,
                        D: _r,
                        z: _r,
                        e: v
                    }, A2(wt, xt, at({
                        $: 0,
                        a: _r
                    })));
                },
                aW: function() {
                    return Ae(je);
                },
                aY: Pe,
                aZ: function(n) {
                    var r, t = n.e, e = n.r, u = n.N, a = n.z;
                    return A2(pu, d([
                        Ze("mx-auto max-w-2xl")
                    ]), d([
                        Bu(n),
                        A4(na, t, a, e, u),
                        u ? A2(du, v, v) : (r = n.v, A2(du, d([
                            Ze("grid grid-cols-[32px_1fr_64px] mt-5 px-2")
                        ]), d([
                            A2(Ke, d([
                                lu(xt(He)),
                                Ze("col-start-2 col-end-3")
                            ]), d([
                                A2(Ve, d([
                                    Ze("flex flex-row align-center")
                                ]), d([
                                    A2(uu, d([
                                        gu("text"),
                                        bu("what now?"),
                                        hu(r),
                                        fu(A2(Je, Ye, xt)),
                                        Ze("w-full input flex-1 outline-none text-lg")
                                    ]), v),
                                    A2(Ge, d([
                                        gu("submit"),
                                        Ze("btn btn-primary ml-2 outline-none")
                                    ]), d([
                                        eu
                                    ]))
                                ]))
                            ]))
                        ])))
                    ]));
                }
            })(rt(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? p(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, $t) : n.Elm = $t;
}($24f6cd628db71622$exports);



var $18sGY = parcelRequire("18sGY");
var $e0aced835f57c843$exports = {};
$e0aced835f57c843$exports = import.meta.resolve("58A47");


const $dd4a844172c9c03c$var$sqliteInitWorkerHref = new URL($e0aced835f57c843$exports).href;
const $dd4a844172c9c03c$var$sqliteWorker = new Worker($dd4a844172c9c03c$var$sqliteInitWorkerHref, {
    type: "module"
});
const $dd4a844172c9c03c$var$messageHandler = (resolve, reject, timeout)=>(event)=>{
        if (event.type === "error") {
            console.error('[SQLite Worker Error]:', event.message);
            clearTimeout(timeout);
            reject(new Error(event.message));
            return;
        }
        const { data: { signal: signal, payload: payload } } = event;
        switch(signal){
            // case 'log':
            //   console.log('[SQLite Worker Log]:', message)
            //   break;
            case (0, $18sGY.WorkerErrorSignal).name:
                const { message: message, stack: stack } = payload;
                console.error('[SQLite Worker Error]:', message);
                clearTimeout(timeout);
                reject(new Error(message, stack));
                break;
            case (0, $18sGY.StorageResultSignal).name:
                // Handle storage result signals if needed
                console.log('[SQLite Worker] Storage Result:', payload);
                break;
            case (0, $18sGY.StorageReadySignal).name:
                const { dbPath: dbPath, sqliteVersion: sqliteVersion } = payload;
                clearTimeout(timeout);
                console.log("\u2705 OPFS_DB is ready!");
                console.log('   Database path:', dbPath);
                console.log('   SQLite version:', sqliteVersion);
                // Make the worker globally available if needed
                window.sqliteWorker = $dd4a844172c9c03c$var$sqliteWorker;
                resolve({
                    worker: $dd4a844172c9c03c$var$sqliteWorker,
                    dbPath: dbPath,
                    sqliteVersion: sqliteVersion
                });
                break;
            default:
                console.warn('[SQLite Worker] Unknown message signal:', signal);
        }
    };
// Promise that resolves when OPFS_DB is ready
const $dd4a844172c9c03c$var$waitForOPFS_DB = new Promise((resolve, reject)=>{
    const timeout = setTimeout(()=>{
        reject(new Error('SQLite initialization timeout after 30 seconds'));
    }, 30000);
    $dd4a844172c9c03c$var$sqliteWorker.addEventListener('message', $dd4a844172c9c03c$var$messageHandler(resolve, reject, timeout));
    $dd4a844172c9c03c$var$sqliteWorker.addEventListener('error', $dd4a844172c9c03c$var$messageHandler(resolve, reject, timeout));
});
// Export the promise for other modules
window.OPFS_DB_READY = $dd4a844172c9c03c$var$waitForOPFS_DB;
const $dd4a844172c9c03c$var$dbResultHandler = (event)=>{
    const { data: data, data: { signal: signal, payload: payload } } = event;
    // console.log('[SQLite Worker] Storage Result:', data)
    window.recapi.ports.results.send({
        payload: payload,
        signal: (0, $18sGY.default)(signal)
    });
};
const $dd4a844172c9c03c$var$queriesListener = (worker)=>{
    return (message)=>{
        console.debug('[Recapi Elm] Query:', message);
        worker.postMessage(message);
    };
};
const $dd4a844172c9c03c$var$initElmApp = ()=>{
    window.recapi = (0, $24f6cd628db71622$exports.Elm).Recapi.init({
        node: document.querySelector('main')
    });
    console.debug('Recapi Elm initialized', window.recapi);
};
// Initialize OPFS_DB and then load other modules
$dd4a844172c9c03c$var$waitForOPFS_DB.then(({ worker: worker, dbPath: dbPath, sqliteVersion: sqliteVersion })=>{
    $dd4a844172c9c03c$var$initElmApp();
    worker.addEventListener('message', $dd4a844172c9c03c$var$dbResultHandler);
    window.recapi.ports.queries.subscribe($dd4a844172c9c03c$var$queriesListener(worker));
    window.recapi.ports.results.send({
        signal: 'tasks',
        payload: [
            {
                id: "t-uuid-id-1",
                note: "task 1",
                status: 0,
                scopeId: 's-uuid-id-1'
            },
            {
                id: "t-uuid-id-2",
                note: "task 2",
                status: 1,
                scopeId: 's-uuid-id-2'
            }
        ]
    });
    console.log("\u2705 All core modules loaded");
}).catch((error)=>{
    console.error("\u274C Failed to initialize OPFS_DB:", error);
});


//# sourceMappingURL=recapi.2bdcebc7.js.map
